module.exports = "/_next/static/images/find-employer-b2a6ec21079b06d65dbac76a2e77a810.png";